import { SET_SELECTED_BRANCH } from 'redux/modules/slot-booking/actions/types';
import { Branch } from 'redux/modules/branches/state/initial-state';
import { saveCookie } from 'utils/cookie';
import { COOKIE_BRANCH_ID } from 'constants/cookies';

export const setSelectedBranch = (branch: Branch) => {
  saveCookie(COOKIE_BRANCH_ID, branch?.id);
  return { type: SET_SELECTED_BRANCH, branch };
};
